module.exports = __webpack_public_path__ + "img/5.3fd335f1.png";